'use client';

import { AbstractIntlMessages, NextIntlClientProvider } from 'next-intl';
import * as Sentry from '@sentry/nextjs';
import { PropsWithChildren } from 'react';

export const I18nProvider = ({
  children,
  defaultMessages,
  locale,
  messages,
}: PropsWithChildren<{
  defaultMessages: AbstractIntlMessages;
  locale: string;
  messages: AbstractIntlMessages;
}>) => {
  const getMessageFallback = ({ key }) => {
    return defaultMessages[key] || key;
  };

  const onError = (error) => {
    Sentry.captureException(error);
  };

  return (
    <NextIntlClientProvider
      messages={messages}
      locale={locale}
      onError={onError}
      getMessageFallback={getMessageFallback}
    >
      {children}
    </NextIntlClientProvider>
  );
};
